// extracted by mini-css-extract-plugin
export var circle = "_s-2";
export var icon = "_s-a";
export var iconHighlight = "_s-0";
export var lg = "_s-8";
export var md = "_s-7";
export var outline = "_s-4";
export var sm = "_s-6";
export var square = "_s-1";
export var xl = "_s-9";
export var xs = "_s-5";
export var xxs = "_s-3";